<template>
    <div class="modal fade show" style="display: block" tabindex="-1" role="dialog">
        <form  @submit.prevent="save">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{translate('remPassword.enterKepPassword')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" :disabled="loading" :aria-label="translate('close')" @click="$emit('close')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="isCompleted">
                        <h5>{{translate('remPassword.passwordChangeSaved')}}</h5>
                        <p v-html="translate('remPassword.saveWarningText:' + data.ProviderName + ':' + data.RemAddress + ':' + data.Username)"></p>
                    </div>
                    <div v-else class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>{{translate('remPassword.remProviderName')}}</label>
                                <input v-model="data.ProviderName" type="text" class="form-control" disabled />
                            </div>
                            <div class="form-group">
                                <label>{{translate('remPassword.remAddress')}}</label>
                                <input v-model="data.RemAddress" type="text" class="form-control" disabled />
                            </div>
                            <div class="form-group" v-if="data.Kind != 'Ptt'">
                                <label>{{translate('incomingDoc.username')}}</label>
                                <input v-model="data.Username" type="text" class="form-control" disabled />
                            </div>                            
                            <div class="form-group">
                                <label v-if="data.Kind != 'Ptt'">{{translate('remPassword.remAuthPasscode')}}</label>
                                <label v-else>{{translate('remPassword.pttRemPasscode')}}</label>
                                <password v-model="data.Password" class="form-control" required maxlength="100" minlength="8" />
                            </div>
                            <div class="form-group" v-if="data.Kind == 'Ptt'">
                                <label>{{translate('remPassword.pttRemPassword')}}</label>
                                <password v-model="data.Chipper" class="form-control" required maxlength="100" minlength="5" />
                            </div>
                            <div class="alert alert-danger" v-if="errorMessage">{{errorMessage}}</div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer footer-button-container">
                    <button type="button" class="btn btn-outline-secondary" :disabled="loading" @click="$emit('close')">{{translate('close')}}</button>
                    <button type="button" v-if="data.LastPasswordSetDate" class="btn btn-outline-danger float-left" :disabled="loading" @click="removePassword">{{translate('remPassword.removePasscode')}}</button>
                    <button type="submit" v-if="!isCompleted" class="btn btn-success" style="width:100px;" v-show="!loading">{{translate('save')}}</button>
<!-- 
                    <div class="row">
                        <div class="col">
                            
                        </div>
                        <div class="col">
                            <button type="button" class="btn btn-outline-secondary" :disabled="loading" @click="$emit('close')">Kapat</button>
                            <button type="submit" v-if="!isCompleted" class="btn btn-success" style="width:100px;" v-show="!loading">Kaydet</button>
                        </div>
                    </div> -->
                </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import formMixin from '../formMixin.js';
import password from '../components/Password.vue'
import axios from 'axios'

export default {
    mixins: [formMixin],
    components: {
        password
    },
    created(){
        this.getData(this.id, true, null);
    },
    data() {
        return {
            isCompleted: false,
            loading: false,
            modelName: 'RemPassword',
            errorMessage: null,
            data: {},
        }
    },
    props: {
        id: String
    },
    methods: {
        save(){
            this.loading = true;
            this.errorMessage = null;
            return axios
              .post(`/RemPassword/post/${this.data.Id}`, this.data)
              .then(x => {
                  this.isCompleted = true;
                  this.loading = false;
                  this.$emit('save', x);
              })
              .catch(x => {
                   window.processErrorResponse(x, this);
                   this.loading = false;
              });
        },
        removePassword(){
            if(confirm(this.translate('warnings.savedRemPasscodeWillBeRemoved'))){
            this.loading = true;
            this.errorMessage = null;
            return axios
                .post(`/${this.modelName}/delete/${this.data.Id}`, this.data)
                .then(x => {
                    console.log("POST Result:", x.data);
                    this.loading = false;
                    this.$emit('save');
                    this.$emit('close');
                })
                .catch(x => window.processErrorResponse(x, this));
            }
        }
    }
}
</script>